import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import DashboardChartMapContainer from './components/DashboardChartMapContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {

  const returnAmbulantData = () => {
    const data = _.get(totalStats, 'res');

    return {
      label: 'Ambulant',
      total: _.get(data, 'AMBULANT.total', 0),
      list: [
        {
          label: 'For Appointment',
          value: _.get(data, 'AMBULANT.FOR APPOINTMENT', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'For Checking',
          value: _.get(data, 'AMBULANT.FOR CHECKING', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'AMBULANT.WAITING FOR PAYMENT', 0),
          borderClassName: 'received',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'AMBULANT.EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'AMBULANT.FOR RESUBMISSION', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Health Certificate Generated',
          value: _.get(data, 'AMBULANT.HEALTH CERTIFICATE GENERATED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'AMBULANT. PAID', 0),
          borderClassName: 'received',
        },
        {
          label: 'Approved',
          value: _.get(data, 'AMBULANT.APPROVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Pending',
          value: _.get(data, 'AMBULANT.PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Pending Lab Test',
          value: _.get(data, 'AMBULANT.PENDING LAB TEST', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Printed',
          value: _.get(data, 'AMBULANT.PRINTED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Received',
          value: _.get(data, 'AMBULANT.RECEIVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Rejected',
          value: _.get(data, 'AMBULANT.REJECTED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnCityEmployeeData = () => {
    const data = _.get(totalStats, 'res');

    return {
      label: 'City Employee',
      total: _.get(data, 'CITY EMPLOYEE.total', 0),
      list: [
        {
          label: 'For Appointment',
          value: _.get(data, 'CITY EMPLOYEE.FOR APPOINTMENT', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'For Checking',
          value: _.get(data, 'CITY EMPLOYEE.FOR CHECKING', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'CITY EMPLOYEE.WAITING FOR PAYMENT', 0),
          borderClassName: 'received',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'CITY EMPLOYEE.EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'CITY EMPLOYEE.FOR RESUBMISSION', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Health Certificate Generated',
          value: _.get(data, 'CITY EMPLOYEE.HEALTH CERTIFICATE GENERATED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'CITY EMPLOYEE.PAID', 0),
          borderClassName: 'received',
        },
        {
          label: 'Approved',
          value: _.get(data, 'CITY EMPLOYEE.APPROVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Pending',
          value: _.get(data, 'CITY EMPLOYEE.PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Pending Lab Test',
          value: _.get(data, 'CITY EMPLOYEE.PENDING LAB TEST', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Printed',
          value: _.get(data, 'CITY EMPLOYEE.PRINTED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Received',
          value: _.get(data, 'CITY EMPLOYEE.RECEIVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Rejected',
          value: _.get(data, 'CITY EMPLOYEE.REJECTED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnContractOfServiceData = () => {
    const data = _.get(totalStats, 'res');

    return {
      label: 'Contract of Service',
      total: _.get(data, 'CONTRACT OF SERVICE.total', 0),
      list: [
        {
          label: 'For Appointment',
          value: _.get(data, 'CONTRACT OF SERVICE.FOR APPOINTMENT', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'For Checking',
          value: _.get(data, 'CONTRACT OF SERVICE.FOR CHECKING', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'CONTRACT OF SERVICE.WAITING FOR PAYMENT', 0),
          borderClassName: 'received',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'CONTRACT OF SERVICE.EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'CONTRACT OF SERVICE.FOR RESUBMISSION', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Health Certificate Generated',
          value: _.get(data, 'CONTRACT OF SERVICE.HEALTH CERTIFICATE GENERATED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'CONTRACT OF SERVICE.PAID', 0),
          borderClassName: 'received',
        },
        {
          label: 'Approved',
          value: _.get(data, 'CONTRACT OF SERVICE.APPROVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Pending',
          value: _.get(data, 'CONTRACT OF SERVICE.PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Pending Lab Test',
          value: _.get(data, 'CONTRACT OF SERVICE.PENDING LAB TEST', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Printed',
          value: _.get(data, 'CONTRACT OF SERVICE.PRINTED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Received',
          value: _.get(data, 'CONTRACT OF SERVICE.RECEIVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Rejected',
          value: _.get(data, 'CONTRACT OF SERVICE.REJECTED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnMarketVendorsData = () => {
    const data = _.get(totalStats, 'res');

    return {
      label: 'Market Vendors',
      total: _.get(data, 'MARKET VENDORS.total', 0),
      list: [
        {
          label: 'For Appointment',
          value: _.get(data, 'MARKET VENDORS.FOR APPOINTMENT', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'For Checking',
          value: _.get(data, 'MARKET VENDORS.FOR CHECKING', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'MARKET VENDORS.WAITING FOR PAYMENT', 0),
          borderClassName: 'received',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'MARKET VENDORS.EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'MARKET VENDORS.FOR RESUBMISSION', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Health Certificate Generated',
          value: _.get(data, 'MARKET VENDORS.HEALTH CERTIFICATE GENERATED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'MARKET VENDORS.PAID', 0),
          borderClassName: 'received',
        },
        {
          label: 'Approved',
          value: _.get(data, 'MARKET VENDORS.APPROVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Pending',
          value: _.get(data, 'MARKET VENDORS.PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Pending Lab Test',
          value: _.get(data, 'MARKET VENDORS.PENDING LAB TEST', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Printed',
          value: _.get(data, 'MARKET VENDORS.PRINTED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Received',
          value: _.get(data, 'MARKET VENDORS.RECEIVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Rejected',
          value: _.get(data, 'MARKET VENDORS.REJECTED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnRenewData = () => {
    const data = _.get(totalStats, 'res');

    return {
      label: 'Renew',
      total: _.get(data, 'RENEW.total', 0),
      list: [
        {
          label: 'For Appointment',
          value: _.get(data, 'RENEW.FOR APPOINTMENT', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'For Checking',
          value: _.get(data, 'RENEW.FOR CHECKING', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'RENEW.WAITING FOR PAYMENT', 0),
          borderClassName: 'received',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'RENEW.EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'RENEW.FOR RESUBMISSION', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Health Certificate Generated',
          value: _.get(data, 'RENEW.HEALTH CERTIFICATE GENERATED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'RENEW.PAID', 0),
          borderClassName: 'received',
        },
        {
          label: 'Approved',
          value: _.get(data, 'RENEW.APPROVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Pending',
          value: _.get(data, 'RENEW.PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Pending Lab Test',
          value: _.get(data, 'RENEW.PENDING LAB TEST', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Printed',
          value: _.get(data, 'RENEW.PRINTED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Received',
          value: _.get(data, 'RENEW.RECEIVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Rejected',
          value: _.get(data, 'RENEW.REJECTED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={returnAmbulantData()} className="mb-3" />
          <DashboardListCard data={returnCityEmployeeData()} className="mb-3" />
          <DashboardListCard data={returnContractOfServiceData()} className="mb-3" />
          <DashboardListCard data={returnMarketVendorsData()} className="mb-3" />
          <DashboardListCard data={returnRenewData()} />
        </div>
        <div className="col-8 pr-0">
          <DashboardChartMapContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
